export enum BannerApiPath {
  GET_ALL_BANNERS = 'Notification/banner',
}
